import React, { useState, useEffect } from   'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';

export default function ListarPrevisitas() {
  const { token, rol } = useAuth();
  const [Cargando, setCargando] = useState(false);
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const [ListaPrevisitas, setListaPrevisitas] = useState([]);
  const [TiposPrevisita, setTiposPrevisita] = useState([]);
  const fetchData = async () => {
    let url = `/encuestassv/previsitas/listarprevisitas`;
    let obj = { rolid: rol, proyecto: 1}
    try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setListaPrevisitas(result.previsitas);
        setTiposPrevisita(result.tiposprevisita);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setCargando(false);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  const ActualizarLista = async () =>  {
    await fetchData();
  }
  const AbrirFormularioPrevisitas = (idPrevisita) =>  {
    navigate(`/encuestassv/formularioprevisita/${idPrevisita}`);
  };
  const columns = [
    {
        name: 'Acciones',
        cell: row => (
        <div>
            <div className="btn-group">
                <button type="button" className="btn btn-info" onClick={() => AbrirFormularioPrevisitas(row.id)} 
                    data-tooltip-id='tooltiparriba'
                    data-tooltip-content="Editar">
                    <i className="fas fa-list nav-icon"></i>
                </button>
            </div>
            
        </div>
        ),
        ignoreRowClick: true,
        width: '5%'
    },
    { name: 'Bloque', selector: row => row.preBloque, sortable: true, width:'5%' },
    { name: 'Apto', selector: row => row.preApto, sortable: true, width: '5%'},
    { name: 'ID', selector: row => row.id, sortable: true, width: '5%'},
    { name: 'Proyecto', selector: row => row.preProyecto, sortable: true, width: '7%'},
    { name: 'Piso', selector: row => row.prePiso, sortable: true, width: '5%'},
    { name: 'Documento', selector: row => row.preDocumento, sortable: true, width: '7%' },
    { name: 'Primer nombre', selector: row => row.prePrimernombre, sortable: true, width: '7%' },
    { name: 'Segundo nombre', selector: row => row.preSegundonombre, sortable: true, width: '7%' },
    { name: 'Primer apellido', selector: row => row.prePrimerapellido, sortable: true, width: '7%' },
    { name: 'Segundo apellido', selector: row => row.preSegundoapellido, sortable: true, width: '7%' },
    { name: 'Tipo población', selector: row => row.preTipopoblacion, sortable: true, width: '8%' },
    { name: 'Propietario', selector: row => row.prePropietario?"SI":"NO", sortable: true, width: '6%' },
    { name: 'Previsita', selector: row => row.prePrevisita, sortable: true, width: '5%' },
    { name: 'Vacunado', selector: row => row.preVacunado?"SI":"NO", sortable: true, width: '5%' },
    { name: 'Logista', selector: row => row.preLogista, sortable: true, width: '15%' },
    { name: 'Encuestador', selector: row => row.preEncuestador, sortable: true, width: '15%' },
    { 
      name: 'Observación', 
      selector: row => row.preObservacion, 
      cell: row => ( <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}> {row.preObservacion} </div> ), 
      width: '25%' },
    ];
  return (
      <div className="content-wrapper">
          <div className="content-header">
              <div className="container-fluid">
                  <div className="row mb-2">
                  <div className="col-sm-6">
                      <h1 className="m-0">Lista previsitas</h1>
                  </div>
                  <div className="col-sm-6">
                      <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                      <li className="breadcrumb-item active">Previsitas</li>
                      </ol>
                  </div>
                  </div>
              </div>
          </div>
          <section className="content">
              <div className="container-fluid">
                    {Cargando && <div className="centered">
                      <div><progress value={null} /></div>
                    </div>}
              </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              
              
              <div className="card card">
                  <div className="card-body">
                      <div className="card-body table-responsive p-0">
                          <button className='form-control' onClick={ActualizarLista}>Actualizar lista</button>
                          <DataTable
                              title="Lista personas para previsita"
                              columns={columns}
                              data={ListaPrevisitas}
                              progressPending={Cargando}
                              pagination
                              paginationServer
                              noDataComponent="No hay datos para mostrar"
                          /> 
                      </div>
                  </div>
              </div>
             
              
                
            </div>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
          </section>
          
      </div>
      
  )
  }